import { useAnalytics } from 'contexts/analytics/AnalyticsProvider';
import { useScrollDepth } from 'hooks/useScrollDepth';
import { type ScrollDepthMilestone } from 'utils/scrollDepth';

/**
 * Fires "Conditions Detail Scroll Depth" as the user scrolls a condition detail
 * page past the default milestones. Thin wrapper over the generic useScrollDepth.
 */
export const useConditionScrollDepth = (condition: string | undefined) => {
  const { trackEvent } = useAnalytics();

  useScrollDepth({
    enabled: !!condition,
    resetKey: condition,
    onMilestone: depth => {
      if (!condition) return;
      // depth is one of the default milestones (25/50/75/100).
      trackEvent('Conditions Detail Scroll Depth', {
        condition,
        depth: depth as ScrollDepthMilestone,
      });
    },
  });
};
